import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CliService } from '../../../api/services';
import { terminalActions } from './terminal.action';
import { concatMap, delay } from 'rxjs';
import { mapResponse } from '@ngrx/operators';
import { getErrorMessage, ZetraError } from '../../shared/errors/error-messages.helper';
import { LoadingState } from '../models/loader.model';

export const terminalLoadEffect = createEffect(
  (actions$ = inject(Actions), cliService = inject(CliService)) => {
    return actions$.pipe(
      ofType(terminalActions.load),
      concatMap((props) =>
        cliService.cliControllerSortRequest(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              terminalActions.done({ data: r.data, state: { value: LoadingState.SUCCESS }, request: props }),
            error: (error: ZetraError) =>
              terminalActions.done({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
